import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { animate } from 'motion/react';
import React, { useState, useEffect } from 'react';
import { useInView } from 'react-intersection-observer';
import { useMediaQuery } from '../../hooks/use-media-query';
import { RotatingElements } from './rotating-elements';
export const Statistics = React.forwardRef(({ firstStat, secondStat, thirdStat, sourceText }, ref) => {
    const showSingleItem = useMediaQuery({ max: 'sm' });
    const stats = [firstStat, secondStat, thirdStat];
    if (showSingleItem) {
        return (_jsxs("div", { ref: ref, className: "grid gap-5 text-center", children: [_jsx("div", { className: "bg-dep-shade-200 mx-auto w-full max-w-360 px-6 py-10 md:px-10 md:py-20 xl:px-25", children: _jsx(RotatingElements, { children: stats.map((stat, i) => (_jsxs(React.Fragment, { children: [_jsx("span", { className: "text-dep-xxl font-dep-display break-normal wrap-anywhere", translate: "no", children: stat.asPercentile ? `${stat.amount}%` : stat.amount }), _jsx("p", { className: "text-dep-sm font-dep-display break-normal wrap-anywhere", children: stat.text })] }, i))) }) }), sourceText] }));
    }
    return (_jsxs("section", { ref: ref, className: "mx-auto grid w-full max-w-360 justify-items-center gap-5 px-6 py-10 sm:justify-items-start md:px-10 md:py-20 xl:px-25", children: [_jsxs("div", { className: "grid w-full gap-y-5 sm:grid-cols-3 sm:justify-between", children: [_jsx(Item, { ...firstStat, formatAmount: (v) => (firstStat.asPercentile ? `${v}%` : `${v}`) }), _jsx(Item, { ...secondStat, formatAmount: (v) => (secondStat.asPercentile ? `${v}%` : `${v}`) }), _jsx(Item, { ...thirdStat, formatAmount: (v) => (thirdStat.asPercentile ? `${v}%` : `${v}`) })] }), sourceText] }));
});
Statistics.displayName = 'Statistics';
const Item = ({ amount, text, formatAmount }) => {
    const [hasMounted, setHasMounted] = useState(false);
    const [animatedAmount, setAnimatedAmount] = useState(0);
    const [ref, inView] = useInView({ threshold: 0.5, triggerOnce: true });
    useEffect(() => {
        setHasMounted(true);
    }, []);
    useEffect(() => {
        if (!inView)
            return;
        const controls = animate(0, amount, {
            duration: 1,
            onUpdate(value) {
                setAnimatedAmount(Math.round(value));
            },
        });
        return () => controls?.stop();
    }, [amount, inView]);
    return (_jsxs("div", { className: "bg-dep-shade-200 rounded-dep-20 grid content-start gap-y-5 p-8 text-left sm:not-first:rounded-l-none sm:not-last:rounded-r-none md:px-10 md:py-15", children: [_jsx("span", { ref: ref, className: "text-dep-xxl font-dep-display break-normal wrap-anywhere", translate: "no", children: formatAmount(hasMounted ? animatedAmount : amount) }), _jsx("span", { className: "text-dep-shade-700 text-dep-sm font-dep-display break-normal wrap-anywhere", children: text })] }));
};
